import { Card } from 'antd';
import React from 'react';
import { MODULES } from '../../../../../common/constants';
import Portal from '../../../../../components/Portal';
import ReferralTable from '../components/ReferralTable';

const Referral = () => (
  <>
    <Portal portalId="header-title-content">
      <div className="portal-header">{MODULES?.REFERRAL}</div>
    </Portal>
    <Card className="full-height-without-nav">
      <ReferralTable />
    </Card>
  </>
);

export default Referral;
